import React, { Component, PropTypes } from 'react';

const css = oxygenCss({
  root: {
    display: 'inline-block',
    fill: 'currentColor',
    verticalAlign: 'middle'
  }
});

class Gift extends Component {
  render() {
    return (
      <svg
        {...this.props}
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        version="1.1"
        className={css.root}
        stroke="none"
        strokeWidth="1"
        fillRule="evenodd"
        opacity="0.5"
      >
        <path d="M8,0 C3.6,0 0,3.6 0,8 C0,12.4 3.6,16 8,16 C12.4,16 16,12.4 16,8 C16,3.6 12.4,0 8,0 L8,0 Z M8,13 C7.4,13 7,12.6 7,12 C7,11.4 7.4,11 8,11 C8.6,11 9,11.4 9,12 C9,12.6 8.6,13 8,13 L8,13 Z M9.5,8.4 C9,8.7 9,8.8 9,9 L9,10 L7,10 L7,9 C7,7.7 7.8,7.1 8.4,6.7 C8.9,6.4 9,6.3 9,6 C9,5.4 8.6,5 8,5 C7.6,5 7.3,5.2 7.1,5.5 L6.6,6.4 L4.9,5.4 L5.4,4.5 C5.9,3.6 6.9,3 8,3 C9.7,3 11,4.3 11,6 C11,7.4 10.1,8 9.5,8.4 L9.5,8.4 Z" />
      </svg>
    );
  }
}

export default Gift;



// WEBPACK FOOTER //
// ./src/js/Cio/Assets/QuestionMark.js